import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EncryptionService {
  // Clave obtenida desde variables de entorno por ambiente
  private readonly secretKey = environment.encryptionKey || 'CondoPal2024SecureKey!@#$%^&*()_+';

  /**
   * Encripta un objeto JSON y retorna un string
   */
  encryptJson(data: any): string {
    const jsonString = JSON.stringify(data);
    const encrypted = CryptoJS.AES.encrypt(jsonString, this.secretKey).toString();
    return encrypted;
  }

  /**
   * Desencripta un string y retorna el objeto JSON original
   */
  decryptJson(encryptedData: string): any {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
      const decryptedString = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedString);
    } catch (error) {
      console.warn('Error al desencriptar datos JSON:', error);
      return {};
    }
  }

  /**
   * Encripta un string
   */
  encryptString(data: string): string {
    const encrypted = CryptoJS.AES.encrypt(data, this.secretKey).toString();
    return encrypted;
  }

  /**
   * Desencripta un string
   */
  decryptString(encryptedData: string): string | null {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, this.secretKey);
      return bytes.toString(CryptoJS.enc.Utf8);
    } catch (error) {
      console.warn('Error al desencriptar string:', error);
      return null;
    }
  }

  /**
   * Genera un hash MD5 de un string (útil para IDs únicos)
   */
  generateMD5Hash(data: string): string {
    return CryptoJS.MD5(data).toString();
  }

  /**
   * Genera un hash SHA256 de un string (más seguro para passwords)
   */
  generateSHA256Hash(data: string): string {
    return CryptoJS.SHA256(data).toString();
  }
}
